import React from 'react';

import { useGoogleLogin } from '@react-oauth/google';

import Text from 'common/components/Text/Text';

import styles from './Login.module.scss';
import { CommonHash } from 'app/types';
import GoogleIcon from 'assets/session/google_icon.svg';

interface CompProps {
  googleSuccess: boolean;
  setGoogleSuccess?: (a: boolean) => void;
  setUserData: (a: CommonHash) => void;
}

const Login = ({ googleSuccess, setGoogleSuccess, setUserData }: CompProps): React.ReactElement => {
  const isSignup = location.pathname == '/signup';
  const googleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      setGoogleSuccess && setGoogleSuccess(true);
      setUserData && setUserData({ provider: 'google_oauth2', token: response.access_token });
    },
  });

  return (
    <div className={styles.googleButton} onClick={() => (googleSuccess ? null : googleLogin())}>
      <img src={GoogleIcon} alt="google_icon" className={styles.googleIcon} />
      <Text size={14} weight={500}>
        {isSignup
          ? googleSuccess
            ? 'Connected with Google'
            : 'Create Account with Google'
          : 'Log in with Google'}
      </Text>
      {googleSuccess && <i className="bi bi-check-circle-fill"></i>}
    </div>
  );
};

export default Login;
